import { NumberId } from 'src/app/shared/state/number-id.model';

export interface Vertex extends NumberId {
  longitude: number;
  latitude: number;
  vertex_class: VertexClass;
  max_box_accepted: number;
  properties: VertexProperties;
  // TODO: Move to entity UI
  invalid?: boolean;
  edge_count?: number;
}

export function createVertex(params: Partial<Vertex>) {
  return {
    vertex_class: VertexClass.PL,
    max_box_accepted: 0,
    properties: {},
    ...params
  } as Vertex;
}

export function createVertexProperties(params: Partial<VertexProperties>) {
  return {
    model: PoleModel.DoubleT,
    height: 0,
    weight: 0,
    comments: '',
    owner_id: null,
    has_switch: false,
    telecom_clamps: 0,
    has_transformer: false,
    ...params
  } as VertexProperties;
}

export interface VertexProperties {
  model: PoleModel;
  height: number;
  weight: number;
  comments: string;
  owner_id: string;
  has_switch: boolean;
  telecom_clamps: number;
  has_transformer: boolean;
}

export enum VertexClass {
  AC = 'AC',
  CO = 'CO',
  PL = 'PL',
  UB = 'UB'
}

export enum PoleModel {
  Circular = 'Circular',
  DoubleT = 'Double T',
  Rectangular = 'Rectangular',
  Wood = 'Wood',
  Metalic = 'Metalic',
  Other = 'Other'
}
